<ion-app (click)="onHide()" [ngClass]="{ 'call-popup-app': isCallPopupRoute }">
    <header id="header" *ngIf="this.userService.id != 0 && !isCallPopupRoute">
        <div class="mobile-menu" (click)="isMenuOpen ? isMenuOpen = false : isMenuOpen = true">
            <ion-icon name="menu-outline"></ion-icon>
        </div>
        <div class="title">
            <h2>{{ routeName }}</h2>
            <p>{{SubName}}</p>
        </div>
        <div class="dealership" (click)="onDealerSelectorClick()">
            <div class="circle" [class.new]="this.userService.storeAlertCount > 0">{{ this.userService.storeAlertCount }}</div>
            <h4>{{ this.userService.dealer.name }}</h4>
            <h5>{{ this.userService.dealer.city }}, {{ this.userService.dealer.province }}</h5>
        </div>
        <div class="menu">
            <div class="circle">{{ this.userService.alertCount }}</div>
            <ion-icon name="notifications-outline" (click)="onAlertClick()"></ion-icon>
            <div class="banner" [hidden]="!(showAlertBanner | async)">
                {{ showAlertBannerText | async }}
            </div>
        </div>
        <div class="user" (click)="show.profile = show.profile ? false : true">
            {{ this.userService.firstName[0] }}{{ this.userService.lastName[0] }}
            <div class="circle"></div>
        </div>
        <div class="profile" *ngIf="show.profile">
            <h5>{{ this.userService.firstName }} {{ this.userService.lastName }}</h5>
            <p>{{ this.userService.email }}</p>
            <div class="logout" (click)="onLogoutClick()">Log out</div>
        </div>
        <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path
                fill="#E9EBEC"
                d="M40.4,-59.3C48,-50,47,-32.5,54.2,-16.2C61.4,0.1,76.9,15,78.4,30.1C79.8,45.1,67.2,60.2,51.8,71.2C36.4,82.2,18.2,89.2,1.3,87.3C-15.5,85.5,-31.1,74.8,-35.1,60.1C-39.1,45.4,-31.6,26.6,-36.6,11.8C-41.6,-3.1,-59.1,-14,-63.5,-26.9C-68,-39.8,-59.3,-54.8,-46.6,-62.4C-33.8,-70,-16.9,-70.3,-0.3,-69.9C16.4,-69.6,32.7,-68.6,40.4,-59.3Z"
                transform="translate(100 100)"
            />
        </svg>
    </header>
    <nav id="navigation" *ngIf="this.userService.id != 0 && !isCallPopupRoute">
        <div class="logo">
         <img src="assets/icon/Advantage-Connect-Logo.svg" alt="Advantage Connect Logo" />
            <ion-icon name="layers"></ion-icon>
        </div>
        <ul [class.standard]="this.userService.admin != 1">
            <li class="disabled" data-tooltip="Dashboard">
                <ion-icon name="pie-chart-sharp"></ion-icon>
            </li>
                <li [routerLink]="'/conversations'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Conversations">
                    <ion-icon name="chatbubble-ellipses-sharp"></ion-icon>
                </li>
                <li class="disabled" data-tooltip="Leads">
                    <ion-icon name="file-tray-full-sharp"></ion-icon>
                </li>
                <li [routerLink]="'/customers'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Customers">
                    <ion-icon name="person-circle-sharp"></ion-icon>
                </li>
                <!-- <li [routerLink]="'/createuser'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Create User">
                    <ion-icon name="create-outline"></ion-icon>
                </li> -->
                <li [routerLink]="'/call-logs'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Call Logs">
                    <ion-icon name="call-sharp"></ion-icon>
                </li>
                <li [routerLink]="'/settings/general'" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" data-tooltip="Settings">
                    <ion-icon name="settings-sharp"></ion-icon>
                </li>
        </ul>
        <div class="logout" (click)="onLogoutClick()" data-tooltip="Log Out">
            <ion-icon name="log-out"></ion-icon>
        </div>
    </nav>
    <div id="menu" *ngIf="isMenuOpen && !isCallPopupRoute">
        <div class="body">
            <div class="menu-top">
                <img src="assets/icon/Advantage-Connect-Logo.svg" alt="Advantage Connect Logo" />
                <button class="menu-close" (click)="isMenuOpen = false" aria-label="Close menu">
                    <ion-icon name="close-outline"></ion-icon>
                </button>
            </div>
            <ul [class.standard]="this.userService.admin != 1">
                <li class="nav-item disabled">
                    <ion-icon name="pie-chart-sharp"></ion-icon> Dashboard
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/conversations'" (click)="isMenuOpen = false">
                        <ion-icon name="chatbubble-ellipses-sharp"></ion-icon> Conversations
                    </a>
                </li>
                <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" *ngIf="this.userService.admin == 1">
                    <a class="menu-link" [routerLink]="'/leads'" (click)="isMenuOpen = false">
                        <ion-icon name="file-tray-full-sharp"></ion-icon> Leads
                    </a>
                </li> -->
                <li class="nav-item disabled">
                    <span class="menu-link">
                        <ion-icon name="file-tray-full-sharp"></ion-icon> Leads
                    </span>
                </li>
                <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/customers'" (click)="isMenuOpen = false">
                        <ion-icon name="person-circle-sharp"></ion-icon> Customers
                    </a>
                </li>
                <!-- <li class="nav-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a class="menu-link" [routerLink]="'/createuser'" (click)="isMenuOpen = false">
                        <ion-icon name="create-outline"></ion-icon> CreateUser
                    </a>
                </li> -->
                <li class="nav-item" routerLinkActive="active">
                    <a class="menu-link" [routerLink]="'/settings/general'" (click)="isMenuOpen = false">
                        <ion-icon name="settings-sharp"></ion-icon> Settings
                    </a>
                </li>
                <li class="nav-item" (click)="onLogoutClick(); isMenuOpen = false">
                    <ion-icon name="log-out"></ion-icon> Logout
                </li>
            </ul>
        </div>
        <div class="underlay" (click)="isMenuOpen = false"></div>
    </div>
    <ion-router-outlet *ngIf="isReady"></ion-router-outlet>
    <app-context-menu *ngIf="!isCallPopupRoute" (markAsRead)="onMarkAsRead()"></app-context-menu>
</ion-app>
